import React from "react";
import L from "leaflet";

const DOWN_EVENTS   = ["pointerdown","touchstart","mousedown"];
const SCROLL_EVENTS = ["wheel","touchmove"];
const CTX_EVENTS    = ["contextmenu"];

function guardDom(el, { disableScroll = true } = {}) {
  if (!el) return () => {};

  const stopDown = (e) => { e.stopPropagation(); }; // don't preventDefault; allow click/up to bubble
  DOWN_EVENTS.forEach(t => el.addEventListener(t, stopDown, { passive: true }));
  const stopCtx = (e) => { e.stopPropagation(); };
  CTX_EVENTS.forEach(t => el.addEventListener(t, stopCtx, { passive: true }));

  const stopScroll = (e) => e.stopPropagation();
  if (disableScroll) SCROLL_EVENTS.forEach(t => el.addEventListener(t, stopScroll, { passive: true }));

  // iOS niceties
  el.style.touchAction = el.style.touchAction || "manipulation";
  el.style.WebkitTapHighlightColor = "transparent";
  el.style.pointerEvents = "auto";

  return () => {
    DOWN_EVENTS.forEach(t => el.removeEventListener(t, stopDown));
    CTX_EVENTS.forEach(t  => el.removeEventListener(t, stopCtx));
    if (disableScroll) SCROLL_EVENTS.forEach(t => el.removeEventListener(t, stopScroll));
  };
}

export class MapEventGuardLegacy extends React.Component {
  constructor(p){ super(p); this.ref = React.createRef(); this.unsub = null; }
  componentDidMount(){ this.unsub = guardDom(this.ref.current, this.props); }
  componentWillUnmount(){ if (this.unsub) this.unsub(); }
  render(){
    const { as:Tag="div", className="", style={}, children, ...rest } = this.props;
    return <Tag ref={this.ref} className={`map-ui-guard ${className}`} style={style} {...rest}>{children}</Tag>;
  }
}

export class MapControlGuardLegacy extends React.Component {
  constructor(p){
    super(p);
    this.c = L.DomUtil.create("div", `leaflet-control map-ui-guard ${p.className||""}`);
    Object.assign(this.c.style, p.style || {});
    this.unsub = null; this.ctrl = null;
  }
  componentDidMount(){
    const { map, position="topright" } = this.props;
    this.unsub = guardDom(this.c, this.props);
    const C = L.Control.extend({ onAdd: () => this.c, onRemove: () => {} });
    this.ctrl = new C({ position });
    if (map) this.ctrl.addTo(map);
  }
  componentWillUnmount(){
    if (this.unsub) this.unsub();
    try { this.props.map && this.ctrl && this.props.map.removeControl(this.ctrl); } catch {}
  }
  render(){ return React.createPortal(this.props.children, this.c); }
}

export function attachLeafletGuards(node, opts){ return guardDom(node, opts); }
